import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';

interface TrustFlowProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const TrustFlowProcessorDetailsPage = ({ processor }: TrustFlowProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="trustflow" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
    </>
  );
};
